import { forwardRef, type Ref, type SVGProps } from "react";
const IconHeatingOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M21 18.11V7a5 5 0 0 0-10 0v11.11a7 7 0 1 0 10 0M16 28a5 5 0 0 1-3.57-8.5l.57-.58V7a3 3 0 0 1 6 0v11.92l.57.58A5 5 0 0 1 16 28" /><path fill="currentColor" d="M17 20.18V8a1 1 0 0 0-2 0v12.18a3 3 0 1 0 2 0" /></svg>;
const ForwardRef = forwardRef(IconHeatingOutlineSVG);
ForwardRef.displayName = "IconHeatingOutline";
export { ForwardRef as IconHeatingOutline };